import script from "./ToggleComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ToggleComponent.vue?vue&type=script&setup=true&lang=js"

import "./ToggleComponent.vue?vue&type=style&index=0&id=63cd06b6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63cd06b6"]])

export default __exports__